export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de facturas"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la factura"])},
          "title_org_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])},
          "title_org_invoice_items": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Items"])},
          "title_org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descuentos"])},
          "total_number_org_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Pagos"])},
          "total_number_org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Descuentos"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to invoices list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoice data"])},
          "title_org_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payments"])},
          "title_org_invoice_items": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Items"])},
          "title_org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounts"])},
          "total_number_org_invoice_payments": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Payments"])},
          "total_number_org_invoice_discounts": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Discounts"])}
        }
      }
    }
  })
}